var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"marquee",staticClass:"marquee"},[_c('div',{ref:"content",staticClass:"marquee-content",class:{scrolling: _vm.isOverflow},style:(_vm.isOverflow ? { '--dist': _vm.dist + 'px' } : null)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }